module.exports = __webpack_public_path__ + "static/img/dark-theme.412ca67e.svg";